import { render, staticRenderFns } from "./actMaleRules.vue?vue&type=template&id=6780ba8f&scoped=true"
import script from "./actMaleRules.vue?vue&type=script&lang=js"
export * from "./actMaleRules.vue?vue&type=script&lang=js"
import style0 from "./actMaleRules.vue?vue&type=style&index=0&id=6780ba8f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6780ba8f",
  null
  
)

export default component.exports